import { Pipe, PipeTransform } from '@angular/core';
import { formatIban } from 'src/app/utils/iban.utils';

@Pipe({
    name: 'iban',
    standalone: false
})
export class IbanPipe implements PipeTransform {

    static format(iban: string, separator = ' '): string {
        return formatIban(iban, separator);
    }
    /**
     * Format IBAN with the given separator
     */
    transform(iban: string, separator = ' '): string {
        return IbanPipe.format(iban, separator);
    }

}
